import React, { useContext  } from 'react';
import Message from './Message';

import { AppContext } from './AppContext'
const ProtectedRoute = ({ element }) => {
    const { isLoggedIn }  = useContext(AppContext)
   return isLoggedIn ? element : <Message />;
  };

export default ProtectedRoute;